import INGREDIENT_SPECIAL_CASE_TYPES from './ingredient-special-case-types'

const INGREDIENT_SPECIAL_CASE_DEFINITION_DEFAULT_VALUES = {
  [INGREDIENT_SPECIAL_CASE_TYPES.PARSING_RULE]: {
    default_ingredients: [],
    exclude_pair: false,
    ingredients_to_check: [],
    shift_indexes: [-1],
    target_ingredient: null,
    tokens: [],
  },
  [INGREDIENT_SPECIAL_CASE_TYPES.IGNORED_COMBINATION]: {
    default_ingredients: [],
    exclude_pair: false,
    ingredients_to_check: [],
    shift_indexes: [0],
    target_ingredient: null,
    tokens: [],
  },
  [INGREDIENT_SPECIAL_CASE_TYPES.DEFAULT_INGREDIENT]: {
    target_ingredient: null,
    exclude_rule: null,
    tokens: [],
  },
}

export default INGREDIENT_SPECIAL_CASE_DEFINITION_DEFAULT_VALUES
